// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "scripts/referrer-portal/" + chunkId + ".chunk/" + {"391": "f8e072f95af7a448","490": "1847a323391c1283","860": "57e7a7da53e83163",}[chunkId] + ".js"
}